module.exports = __webpack_public_path__ + "static/media/down.440d87b9.png";